import ENivelUsuarioERP from "@/shared/enums/ENivelUsuarioERP";

export default class CUsuario {
  codigo: number | string = 0;
  nome: string = '';
  nivel: ENivelUsuarioERP = ENivelUsuarioERP.Indefinido

  constructor(pModel?: Partial<CUsuario>) {
    if (!pModel) {
      return;
    }

    this.codigo = pModel.codigo || this.codigo;
    this.nome = pModel.nome || this.nome;
    this.nivel = pModel.nivel || this.nivel
  }
}
